/*
  All-reviews page: points the single Loox widget at the chosen product.
  Before Loox upgrades #looxReviews we just set its data attributes. After it has built its
  iframe we swap the iframe URL in place, which keeps Loox's auto-height working. If the URL
  ever stops looking like /widget/<shop>/reviews[/<product>], we reload with ?product= instead.
*/
(function () {
  var root = document.querySelector('[data-all-reviews]');
  if (!root) return;

  var widget = root.querySelector('#looxReviews');
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ar-chip]'));
  var focusBars = Array.prototype.slice.call(root.querySelectorAll('[data-ar-focus]'));
  var scroller = root.querySelector('.all-reviews__nav');
  if (!widget || !chips.length) return;

  var REVIEWS_PATH = /(\/widget\/[^/]+\/reviews)(\/\d+)?\/?$/;

  function chipFor(handle) {
    if (!handle) return chips[0];
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].dataset.handle === handle) return chips[i];
    }
    return null;
  }

  function setUrl(handle) {
    var url = new URL(window.location.href);
    if (handle) url.searchParams.set('product', handle);
    else url.searchParams.delete('product');
    window.history.replaceState(null, '', url.toString());
  }

  function pointWidget(productId, handle) {
    var frame = widget.querySelector('iframe');

    if (!frame) {
      if (productId) {
        widget.setAttribute('data-product-id', productId);
        widget.setAttribute('data-reviews-to-display', 'product_reviews_only');
      } else {
        widget.removeAttribute('data-product-id');
        widget.removeAttribute('data-reviews-to-display');
      }
      return;
    }

    var src = new URL(frame.src, window.location.href);
    if (!REVIEWS_PATH.test(src.pathname)) {
      setUrl(handle);
      window.location.reload();
      return;
    }

    src.pathname = src.pathname.replace(REVIEWS_PATH, function (_, base) {
      return base + (productId ? '/' + productId : '');
    });
    if (productId) src.searchParams.set('reviews_to_display', 'product_reviews_only');
    else src.searchParams.delete('reviews_to_display');

    widget.classList.add('is-loading');
    frame.addEventListener(
      'load',
      function () {
        widget.classList.remove('is-loading');
      },
      { once: true }
    );
    frame.src = src.toString();
  }

  // Bring a chip into view inside the mobile scroller without moving the page.
  function revealChip(chip) {
    if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;
    var box = scroller.getBoundingClientRect();
    var c = chip.getBoundingClientRect();
    if (c.left < box.left + 16) scroller.scrollLeft += c.left - box.left - 16;
    else if (c.right > box.right - 16) scroller.scrollLeft += c.right - box.right + 16;
  }

  function select(chip, userInitiated) {
    var productId = chip.dataset.productId;
    var handle = chip.dataset.handle;

    chips.forEach(function (c) {
      c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
    });
    focusBars.forEach(function (bar) {
      bar.hidden = bar.getAttribute('data-ar-focus') !== productId;
    });

    pointWidget(productId, handle);
    revealChip(chip);
    if (userInitiated) setUrl(handle);
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      if (chip.getAttribute('aria-pressed') === 'true') return;
      select(chip, true);
    });
  });

  var initial = chipFor(new URLSearchParams(window.location.search).get('product'));
  if (initial && initial !== chips[0]) select(initial, false);
})();
